import { serializeQuery } from '../lib/urlQuery.js';

export default {
    name: 'savedsearchesservice',
    dependencies: ['xhrservice'],
    callable(xhr) {
        function getSavedSearch(id) {
            return getSavedSearches().then(searches =>
                _getSavedSearchById(searches, id)
            );
        }

        function getSavedSearches() {
            return xhr
                .getJson('/user/savedsearches.json')
                .then(e => (e && e.savedSearches) || [])
                .catch(() => []);
        }

        function getSavedSearchesListForFrontpage() {
            return xhr
                .getJson('/user/savedsearchesfrontpage.json')
                .then(
                    e =>
                        (e && e.savedSearches && e.savedSearches.searches) || []
                )
                .catch(() => []);
        }

        function createSavedSearch(market, segment, args, name, notify) {
            delete args.page; // saved searches should always show first page.

            const payload = {
                name,
                uri: serializeQuery(args),
            };

            if (notify) {
                payload.notify = ['mail', 'push', 'stream', 'web'];
            } else {
                payload.notify = 'stream';
            }

            return _sendSavedSearchRequest(market, segment, payload);
        }

        // eslint-disable-next-line max-params
        function updateSavedSearch(
            market,
            segment,
            args,
            name,
            id,
            notifications
        ) {
            const payload = {
                name,
                uri: serializeQuery(args),
                storedId: id,
                notify: notifications,
            };
            return _sendSavedSearchRequest(market, segment, payload);
        }

        function updateSavedSearchByType(savedSearchInfo) {
            const payload = {
                name: savedSearchInfo.name,
                uri: savedSearchInfo.url,
                storedId: savedSearchInfo.id,
                type: savedSearchInfo.type,
            };
            payload.notify = ['stream'];
            if (savedSearchInfo.notifyByEmailValue) {
                payload.notify.push('mail');
            }
            if (savedSearchInfo.notifyByAppValue) {
                payload.notify.push('push');
            }
            if (savedSearchInfo.notifyByWebValue) {
                payload.notify.push('web');
            }

            return _sendSavedSearchRequest(
                savedSearchInfo.market,
                savedSearchInfo.segment,
                payload
            );
        }

        function _sendSavedSearchRequest(market, segment, payload) {
            payload.csrfToken = document.querySelector(
                "meta[name='csrf-token']"
            ).content;
            return xhr.request({
                url: `/user/${market}/${segment}/search.json`,
                method: 'POST',
                data: payload,
            });
        }

        function _getSavedSearchById(searches, id) {
            return searches
                .map(searchesByAVertical =>
                    searchesByAVertical.searches.find(searchHasMatchingId)
                )
                .filter(e => e)[0];

            function searchHasMatchingId(search) {
                return search.id === id;
            }
        }

        const exports = {
            getSavedSearch,
            getSavedSearches,
            getSavedSearchesListForFrontpage,
            createSavedSearch,
            updateSavedSearch,
            updateSavedSearchByType,
        };

        return exports;
    },
};



// WEBPACK FOOTER //
// ./services/savedsearches.js